import React, { Component } from "react";
import Dialog from "material-ui/Dialog";
import Clear from "material-ui/svg-icons/content/clear";
import Select from "react-select";
import { buttonBlueColor } from "../../utils/utility";
import "./reassign-client-dialog.css";
import remove from "lodash/remove";
import orderBy from "lodash/orderBy";
const styleSheet = {
  table_th: {
    fontSize: "14px",
  },
  table: {
    width: "100%",
    color: "black",
  },
  table_tr: {
    height: "30px",
  },
  thead: {},
  checkbox: {
    display: "inline-block",
    border: "1px solid #827e7e",
    background: "white",
    width: "15px",
    height: "15px",
    cursor: "pointer",
    marginTop: "4px",
    position: "relative",
  },
  firstTh: {
    width: "28px",
    textAlign: "center",
  },
  icon: {
    position: "absolute",
    left: "2px",
    top: "-3px",
    fontSize: "13px",
    fontWeight: "normal",
  },
};

class ReassignClientDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      assignClientValue: "",
      assignClientLabel: "",
      ifAssignDisabled: true,
      copy_client_assignments: [], // this array for assign button changing
      controlAllSelected: false,
      selectedRow: "none",
      originalAccountManagerName: "",
      ifDisabledSaveButton: true,
    };
    this.arr_for_index = []; // record the index of selected
    this.flag = true; // control all selection
  }
  closeDialog() {
    // reset the table data
    this.arr_for_index = []; // reset
    if (this.props.ifReassignSuccess) {
      this.props.getClientAssignmentsAgain();
    }
    let arr1 = this.state.copy_client_assignments;
    for (const v of this.state.copy_client_assignments) {
      v.accountManagerName = this.state.originalAccountManagerName;
    }
    let len = this.state.copy_client_assignments.length;
    const a = "list";
    for (let i = 0; i < len; i++) {
      this.setState({
        [a + i]: "",
      });
    }
    this.setState({
      controlAllSelected: false,
      selectedRow: "none",
      copy_client_assignments: arr1,
      ifDisabledSaveButton: true,
      ifAssignDisabled: true,
    });
    this.props.closeDialog();
    this.props.rollBackReassign();
  }
  componentDidMount() {}
  componentWillReceiveProps(nextProps) {
    this.setState({
      originalAccountManagerName:
        nextProps.client_assignments.length > 0 &&
        nextProps.client_assignments[0].accountManagerName,
      copy_client_assignments: orderBy(
        nextProps.client_assignments,
        ["clientName"],
        ["asc"],
      ),
    });
  }
  handleAssignClient(val) {
    this.setState({
      assignClientValue: val.value,
      assignClientLabel: val.label,
    });
  }
  handleAssign(e) {
    // assign button
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    if (
      this.state.assignClientLabel !== "" &&
      this.state.selectedRow !== "none"
    ) {
      if (this.state.selectedRow === "all") {
        // this.setState({
        //   copy_client_assignments: this.props.client_assignments.forEach((item) => item.accountManagerName = this.state.assignClientLable)
        // })
        let obj = [];
        for (let i of this.state.copy_client_assignments) {
          i.accountManagerName = this.state.assignClientLabel;
          obj.push(i);
        }
        this.setState({
          copy_client_assignments: obj,
          ifDisabledSaveButton: false,
        });
      } else if (this.state.selectedRow.length > 0) {
        let obj = [];
        for (const [
          key,
          value,
        ] of this.state.copy_client_assignments.entries()) {
          for (const v of this.state.selectedRow) {
            if (v === key) {
              value.accountManagerName = this.state.assignClientLabel;
            }
            obj.push(value);
          }
        }
        this.setState({
          copy_client_assignments: this.translateSetToArray(obj),
          ifDisabledSaveButton: false,
        });
      }
    }
  }
  handleAllCheck() {
    if (this.flag) {
      if (this.state.copy_client_assignments.length === 0) {
        this.setState({
          ifAssignDisabled: true,
        });
      } else {
        this.setState({
          controlAllSelected: true,
          selectedRow: "all",
          ifAssignDisabled: false,
        });
      }
      this.flag = false;
    } else {
      let arr1 = this.state.copy_client_assignments;
      for (const v of this.state.copy_client_assignments) {
        v.accountManagerName = this.state.originalAccountManagerName;
      }
      let len = this.state.copy_client_assignments.length;
      const a = "list";
      for (let i = 0; i < len; i++) {
        this.setState({
          [a + i]: "",
        });
      }
      this.setState({
        controlAllSelected: false,
        selectedRow: "none",
        ifAssignDisabled: true,
        ifDisabledSaveButton: true,
        copy_client_assignments: arr1,
      });
      this.flag = true;
    }
  }
  translateSetToArray(arr) {
    return [...new Set(arr)];
  }
  handleListCheckbox(idx) {
    if (this.state.selectedRow === "all") {
      return false;
    }
    const a = "list";
    if (typeof this.state[a + idx] !== "number") {
      this.arr_for_index.push(idx);
      let arr = this.translateSetToArray(this.arr_for_index.sort());
      this.setState({
        [a + idx]: idx,
        selectedRow: arr,
        ifAssignDisabled: false,
      });
    } else if (typeof this.state[a + idx] === "number") {
      remove(this.arr_for_index, n => n === idx);
      let arr1 = this.state.copy_client_assignments;
      arr1[idx].accountManagerName = this.state.originalAccountManagerName;
      this.setState(
        {
          [a + idx]: "",
          selectedRow:
            this.arr_for_index.length === 0 ? "none" : this.arr_for_index,
          copy_client_assignments: arr1,
        },
        () => {
          if (this.state.selectedRow === "none") {
            this.setState({
              ifAssignDisabled: true,
              ifDisabledSaveButton: true,
            });
          }
        },
      );
    }
  }
  handleSave() {
    let obj = [];
    for (const v of this.state.selectedRow) {
      let $obj = {};
      $obj.clientId = this.state.copy_client_assignments[v].clientId;
      $obj.accountManagerUserIds = [this.state.assignClientValue];
      obj.push($obj);
    }

    this.props.reassingAccountManager(
      this.props.originAccountManagerUserId,
      obj,
    );
  }
  render() {
    return (
      <div className="reassign-client">
        <Dialog
          modal={true}
          contentStyle={{ width: "45%" }}
          open={this.props.open}
          bodyStyle={{ overflow: "visible" }}
        >
          <div className="wrapper">
            <Clear
              style={{
                position: "absolute",
                right: "1em",
                cursor: "pointer",
                top: "1em",
              }}
              onClick={() => this.closeDialog()}
            />
            {!this.props.ifReassignSuccess ? (
              <div className="reassign-box">
                {/^system administrator/gi.test(this.props.roleName) && (
                  <h2
                    style={{
                      fontSize: "16px",
                      fontWeight: "bolder",
                      color: "black",
                    }}
                  >
                    REASSIGN CLIENTS
                  </h2>
                )}
                {/^(administrator)/gi.test(this.props.roleName) && (
                  <h2
                    style={{
                      fontSize: "16px",
                      fontWeight: "bolder",
                      color: "black",
                    }}
                  >
                    REASSIGN BUSINESS UNITS
                  </h2>
                )}
                <div
                  className="table-wrapper"
                  style={{ border: "1px solid black", overflow: "hidden" }}
                  ref="tableWrapper"
                >
                  <div>
                    <table style={styleSheet.table}>
                      <thead>
                        <tr
                          style={{
                            ...styleSheet.table_tr,
                            background: "#e4e4e4",
                            borderBottom: "1px solid black",
                          }}
                        >
                          <th style={styleSheet.firstTh}>
                            <div
                              style={styleSheet.checkbox}
                              onClick={() => this.handleAllCheck()}
                            >
                              <span
                                style={{
                                  ...styleSheet.icon,
                                  display: this.state.controlAllSelected
                                    ? "inline-block"
                                    : "none",
                                }}
                              >
                                X
                              </span>
                            </div>
                          </th>
                          {/^system administrator/gi.test(
                            this.props.roleName,
                          ) && (
                            <th
                              style={{ ...styleSheet.table_th, width: "46.8%" }}
                            >
                              Clients
                            </th>
                          )}
                          {/^(administrator)/gi.test(this.props.roleName) && (
                            <th
                              style={{ ...styleSheet.table_th, width: "46.8%" }}
                            >
                              Business Units
                            </th>
                          )}
                          <th style={{ ...styleSheet.table_th, width: "48%" }}>
                            Assigned
                          </th>
                        </tr>
                      </thead>
                    </table>
                  </div>
                  <div
                    className="table-box"
                    style={{ maxHeight: "300px", overflowY: "scroll" }}
                  >
                    <table className="table-reassign" style={styleSheet.table}>
                      <tbody>
                        {this.state.copy_client_assignments.map(
                          (item, index) => (
                            <tr
                              key={index}
                              style={{
                                ...styleSheet.table_tr,
                                background:
                                  this.state[`list${index}`] === index ||
                                  this.state.controlAllSelected
                                    ? "lightgrey"
                                    : "",
                              }}
                            >
                              <td style={styleSheet.firstTh}>
                                <div
                                  style={styleSheet.checkbox}
                                  onClick={() => this.handleListCheckbox(index)}
                                >
                                  <span
                                    style={{
                                      ...styleSheet.icon,
                                      display:
                                        this.state[`list${index}`] === index ||
                                        this.state.controlAllSelected
                                          ? "inline-block"
                                          : "none",
                                    }}
                                  >
                                    X
                                  </span>
                                </div>
                              </td>
                              <td
                                style={{
                                  ...styleSheet.table_th,
                                  width: "47.9%",
                                }}
                              >
                                {item.clientName}
                              </td>
                              <td
                                style={{
                                  ...styleSheet.table_th,
                                  width: "46.7%",
                                }}
                              >
                                {item.accountManagerName}
                              </td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
                <div
                  className="assign-client-to clearfix"
                  style={{
                    marginTop: "1em",
                    paddingBottom: "1em",
                    borderBottom: "2px solid black",
                  }}
                >
                  {/^system administrator/gi.test(this.props.roleName) && (
                    <span
                      style={{
                        float: "left",
                        marginTop: "0.6em",
                        color: "black",
                      }}
                    >
                      Assign Clients to
                    </span>
                  )}
                  {/^(administrator)/gi.test(this.props.roleName) && (
                    <span
                      style={{
                        float: "left",
                        marginTop: "0.6em",
                        color: "black",
                      }}
                    >
                      Assign Business Units to
                    </span>
                  )}
                  <div
                    className="box"
                    style={{ float: "left", width: "13.6em" }}
                    id="box"
                  >
                    <Select
                      className="reassign-client-select"
                      value={this.state.assignClientValue}
                      clearable={false}
                      options={this.props.account_manager}
                      style={{ float: "left" }}
                      onChange={val => this.handleAssignClient(val)}
                    />
                  </div>
                  <button
                    disabled={this.state.ifAssignDisabled}
                    onClick={e => this.handleAssign(e)}
                    style={{
                      float: "left",
                      marginLeft: "0.5em",
                      fontSize: "12px",
                      color: "white",
                      height: "30px",
                      marginTop: "5px",
                      background: buttonBlueColor(),
                      border: "none",
                    }}
                  >
                    ASSIGN
                  </button>
                </div>
              </div>
            ) : (
              <p style={{ color: "black", textAlign: "center" }}>
                {/^system administrator/gi.test(this.props.roleName)
                  ? "Reassign clients success"
                  : "Reassign business units success"}
              </p>
            )}
            <div
              className="btns"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "2em",
              }}
            >
              <p style={{ fontSize: "12px", color: "red" }}>
                {/*{this.props.client_assignments_error}*/}
              </p>
              <div className="">
                <button
                  onClick={() => this.closeDialog()}
                  style={{
                    background: "white",
                    color: "black",
                    border: "1px solid black",
                    fontSize: "14px",
                    padding: "0.3em 0.5em",
                    marginRight: "0.4em",
                  }}
                >
                  {this.props.ifReassignSuccess ? "CLOSE" : "CANCEL"}
                </button>
                {!this.props.ifReassignSuccess && (
                  <button
                    disabled={this.state.ifDisabledSaveButton}
                    onClick={() => this.handleSave()}
                    style={{
                      background: buttonBlueColor(),
                      color: "white",
                      border: "none",
                      fontSize: "14px",
                      padding: "0.3em 0.5em",
                    }}
                  >
                    SAVE
                  </button>
                )}
              </div>
            </div>
          </div>
        </Dialog>
      </div>
    );
  }
}

export default ReassignClientDialog;



// WEBPACK FOOTER //
// ./src/components/Employees/ReassignClientDialog.jsx